import { useQuery } from '@tanstack/react-query';
import getAdminAccountApi, { AdminAccount } from 'api-calls/account';

export const ADMIN_ACCOUNT_QUERY_KEY = [getAdminAccountApi.queryKey];

// The signed-in staff member, including whether they have a password yet.
export function useAdminAccount() {
  return useQuery<AdminAccount>({
    queryKey: ADMIN_ACCOUNT_QUERY_KEY,
    queryFn: async () => {
      const response: any = await getAdminAccountApi.queryFn(undefined);
      return response?.data ?? response;
    },
    staleTime: 5 * 60 * 1000,
  });
}
